
<template>
    <el-select v-model="selectValues" multiple @change="changeSelect">
        <el-option v-if="options.length" :label="reuseLan.selectAll.label" :value="reuseLan.selectAll.key">
            <el-checkbox v-model="isSelectAll" @click.native.prevent>{{reuseLan.selectAll.label}}</el-checkbox>
        </el-option>
        <hr v-if="options.length"/>
        <el-option v-for="item in options" :key="item[props.value]" :label="item[props.label]" :value="item[props.value]">
            <el-checkbox v-model="item.isCheck" @click.native.prevent>{{item[props.label]}}</el-checkbox>
        </el-option>
        <hr v-if="options.length"/>
        <el-option v-if="options.length" :label="reuseLan.rememberMyChoice.label" :value="reuseLan.rememberMyChoice.key">
            <!-- <el-checkbox v-model="rememberMyChoice" @click.native.prevent>{{reuseLan.rememberMyChoice.label}}</el-checkbox> -->
        </el-option>
    </el-select>
</template>

<script>
export default {
    mixins: [require('common/mixin/base').base({ reuseLan: 'reuse' })],
    model: {
        prop: "initSelectValues",
        event: "change"
    },
    props: {
        initSelectValues: {
            type: Array,
            default: () => []
        },
        // 下拉选项
        options: {
            type: Array,
            default: () => []
        },
        // 选项键值对
        props: {
            type: Object,
            default: () => {
                return {
                    label: "value",
                    value: "key"
                }
            }
        },
        initPlaceholder: {
            type: String,
            default: () => ""
        },
        initRemember: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectValues: [],
            isSelectAll: false,
            // rememberMyChoice: false,
        }
    },
    watch: {
        // 监听（全选，全不选以及checkbox是否勾选）
        selectValues: function () { this.changeHandler() },
        options: function () { this.changeHandler() },
    },
    created() {
        // 回显
        this.selectValues = this.initSelectValues
        // this.rememberMyChoice = this.initRemember
        if(this.initRemember) this.selectValues.push(this.reuseLan.rememberMyChoice.key)
    },
    updated() {
        this.$children[0].$children[1].$refs.input.placeholder = this.initPlaceholder
    },
    methods: {
        changeSelect(val) {
            if (val.includes(this.reuseLan.selectAll.key)) {
                const cancelSelectAll = val.length > this.options.length
                this.selectValues = cancelSelectAll ? [] : this.options.map(item => item[this.props.value])
            }
            const rememberKey = this.reuseLan.rememberMyChoice.key
            if(!this.selectValues.includes(rememberKey) && val.includes(rememberKey)) this.selectValues.push(rememberKey)
            this.$emit("change", this.selectValues)
        },
        changeHandler() {
            const arr = this.selectValues;
            let selectAll = true
            this.options.forEach(item => {
                item.isCheck = arr.includes(item[this.props.value])
                if(selectAll && !item.isCheck) selectAll = false;
            })
            // this.rememberMyChoice = arr.includes(this.reuseLan.rememberMyChoice.key)
            this.isSelectAll = selectAll
            // 强制更新（checkbox回显)
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="scss" scoped>
    hr {
        margin: 0px;
        border: 1;
    }
    /deep/ .el-select__tags {
        display: none;
    }
    /deep/ input::placeholder{
        color: #333;
    }
</style>>



// WEBPACK FOOTER //
// src/components/multipleSelect.vue